var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31822 12.7172L2.05156 11.4505C1.5349 10.9338 1.5349 10.0838 2.05156 9.56717L3.31822 8.30048C3.53489 8.08382 3.70989 7.65881 3.70989 7.35881V5.56713C3.70989 4.83379 4.30989 4.23381 5.04323 4.23381H6.83489C7.13489 4.23381 7.55989 4.05884 7.77656 3.84217L9.04322 2.57549C9.55988 2.05882 10.4099 2.05882 10.9266 2.57549L12.1932 3.84217C12.4099 4.05884 12.8349 4.23381 13.1349 4.23381H14.9266C15.6599 4.23381 16.2599 4.83379 16.2599 5.56713V7.35881C16.2599 7.65881 16.4349 8.08382 16.6516 8.30048L17.9182 9.56717C18.4349 10.0838 18.4349 10.9338 17.9182 11.4505L16.6516 12.7172C16.4349 12.9339 16.2599 13.3589 16.2599 13.6589V15.4504C16.2599 16.1838 15.6599 16.7839 14.9266 16.7839H13.1349C12.8349 16.7839 12.4099 16.9588 12.1932 17.1755L10.9266 18.4422C10.4099 18.9589 9.55988 18.9589 9.04322 18.4422L7.77656 17.1755C7.55989 16.9588 7.13489 16.7839 6.83489 16.7839H5.04323C4.30989 16.7839 3.70989 16.1838 3.70989 15.4504V13.6589C3.70989 13.3505 3.53489 12.9255 3.31822 12.7172Z",
    stroke: "#1BA904",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13L12.5 8",
    stroke: "#1BA904",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0762 12.5832H12.0836",
    stroke: "#1BA904",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91209 8.41667H7.91957",
    stroke: "#1BA904",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountShape);
export default __webpack_public_path__ + "static/media/discount-shape.a12d1f3ba36d8856c0f89e61b5fb90c5.svg";
export { ForwardRef as ReactComponent };